module.exports = "<as-user-avatar\n        [diameter]=diameter\n        [imageURL]=imageURL\n        >\n        </as-user-avatar>"